module.exports = "<div class=\"search-box products-search\" ng-keyup=\"trigger($event)\">\n\t<input type=\"text\" ng-model=\"searchText\" placeholder=\"Pretraga proizvoda\" autofocus rc-autofocus>\n\t<i class=\"material-icons search\">search</i>\n\t<button ng-click=\"search()\" class=\"search-trigger\" ng-class=\"{show: searchText}\">traži</button>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./scripts/apps/search/directives/views/search-directive.html
// module id = 475
// module chunks = 0